/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect } from 'react';
import { useItems } from '../hooks/itemsHelper';
import { makeEventListener } from '../hooks/eventListener';
export const WixProGalleryWithItemProcessing = Gallery => props => {
  const {
    disableItemProcessors,
    itemsSrc,
    isExternalPagination,
    totalItemsCount,
    items,
    addedItems,
    ...rest
  } = props;
  const {
    itemsToRender,
    handleGetMoreItemsRequest,
    addExternalItems
  } = useItems(disableItemProcessors ? [] : items, itemsSrc, undefined, undefined, isExternalPagination);
  useEffect(() => {
    if (addedItems && (addedItems == null ? void 0 : addedItems.length) > 0) {
      addExternalItems(addedItems);
    }
  }, [addedItems]);
  const eventsListener = !isExternalPagination ? makeEventListener().NEED_MORE_ITEMS(eventData => {
    handleGetMoreItemsRequest(eventData);
  }).done(props.eventsListener) : props.eventsListener;
  const galleryProps = {
    ...rest,
    items: disableItemProcessors ? items : itemsToRender,
    totalItemsCount: isExternalPagination ? totalItemsCount || Infinity : items.length,
    eventsListener
  };
  return /*#__PURE__*/React.createElement(Gallery, galleryProps);
};
//# sourceMappingURL=withItems.js.map